import { Nav } from '~/components/MasterDetail/components/Master';

export const navBarItems: Array<Nav> = [
  {
    type: 'link',
    to: '',
    icon: 'gear',
    name: 'Algemeen',
  },
  { type: 'link', to: '/design', icon: 'layout', name: 'Ontwerp' },
  { type: 'separator' },
  { type: 'heading', title: "Pagina's & teksten" },
  {
    type: 'link',
    to: '/address',
    icon: 'file',
    name: '1. Adres',
  },
  {
    type: 'link',
    to: '/propertyType',
    icon: 'file',
    name: '2. Type Huis',
  },
  {
    type: 'link',
    to: '/why',
    icon: 'file',
    name: '3. Reden waardecheck',
  },
  {
    type: 'link',
    to: '/when',
    icon: 'file',
    name: '4. Verhuisintentie',
  },
  {
    type: 'link',
    to: '/comparison',
    icon: 'file',
    name: '5.1. Swipen',
  },
  {
    type: 'link',
    to: '/valuationFailure',
    icon: 'file',
    name: '5.2. Geen matches',
  },
  {
    type: 'link',
    to: '/appraisalRequest',
    icon: 'file',
    name: '5.3. Waardebepaling',
  },
  {
    type: 'link',
    to: '/appraisalRequestSuccess',
    icon: 'file',
    name: '5.4. Waardebepaling aangevraagd',
  },
  {
    type: 'link',
    to: '/valuationSuccess',
    icon: 'file',
    name: '6. Contactgegevens',
  },
  {
    type: 'link',
    to: '/report',
    icon: 'file',
    name: '7.1. Rapport',
  },
  {
    type: 'link',
    to: '/about',
    icon: 'file',
    name: '7.2. Over ons',
  },
];
